import { HorizonInterval } from './Horizon';

export class AddHorizonWizardModel {
    addHorizon: HorizonInterval;
    sequencing: Array<HorizonInterval>;
    copyData: boolean;
    copyOwnership: boolean;
    copyLeasehold: boolean;
    copyWorkingInterest: boolean;
    copyOverridingRoyaltyInterest: boolean;
}



// WEBPACK FOOTER //
// ./src/models/AddHorizonWizard.ts